/**
 * Text and data processing utilities for canvas interactions
 * Extracted from MyCanvas.js to reduce file size
 */

/**
 * Gets text style for a given text element and style type
 * @param {Object} text - Text element object
 * @param {string} styleType - Type of style to retrieve
 * @returns {Object} Style object or empty object if not found
 */
export const getTextStyle = (text, styleType) => {
  return text?.textStyles?.[styleType] || {};
};

/**
 * Deduplicates array items by name property
 * @param {Array} arr - Array to deduplicate
 * @returns {Array} Deduplicated array
 */
export const deduplicateByName = (arr) =>
  arr.filter(
    (item, idx, self) => idx === self.findIndex((a) => a.name === item.name)
  );

/**
 * Sanitizes ID string for IndexedDB storage
 * @param {string} id - ID to sanitize
 * @param {string} fallback - Fallback value if ID is invalid
 * @returns {string} Sanitized ID
 */
export const sanitizeId = (id, fallback = "currentCanvas") => {
  if (!id || typeof id !== "string") {
    return fallback;
  }
  // Remove any characters that could cause IndexedDB key issues
  const sanitized = id.replace(/[^a-zA-Z0-9_-]/g, "_");
  if (sanitized !== id) {
    // Optional: log when sanitization occurs
  }
  return sanitized;
};
